import { useMemo } from "react";
import Modal from "./Modal";
import IFrameListener from "./shared/IFrameListener";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import styled from "@emotion/styled";
import m from "@utils/strings";
import { IModalProps } from "./Modal";

// Types
import { IBiometry, IBiometryData } from "@store/reducers/biometryReducer";
import { IStoreState } from "@store/index";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch, UnknownAction } from "redux";
import { saveBiometrics } from "@store/actions";

export interface IBiometricsModalProps extends IModalProps {
  url?: string;
  saveBiometrics: (data: IBiometryData) => void;
  onBiometryResponse: (data: IBiometryData) => void;
  biometrics: IBiometry;
}

const Header = styled.div`
  width: 100%;
  padding: 15px;
  border-radius: 8px 8px 0 0;
  background-color: ${(props: any) => {
    return props?.background || "#FFF";
  }};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

function BiometricsModal(props: IBiometricsModalProps) {
  const open = useMemo(
    () => props.biometrics.required && !props.biometrics.data?.response,
    [props.biometrics.required, props.biometrics.data?.response]
  );

  const handleMessageReceived = (response: IBiometryData) => {
    props.saveBiometrics(response);
    props.onBiometryResponse(response);
  };

  return (
    <Modal open={open}>
      <Header>
        <Typography variant="h5" role="heading">
          {m.MODAL_RECONHECIMENTO_FACIAL.TITULO}
        </Typography>
        <IconButton onClick={props?.onClose}>
          <CloseIcon />
        </IconButton>
      </Header>
      <IFrameListener<IBiometryData>
        style={{ width: "100%", height: "calc(100% - 30px)" }}
        frameBorder="0"
        origin={window.location.origin}
        src={props?.url}
        onMessageReceived={handleMessageReceived}
        allow="camera"
      />
    </Modal>
  );
}

const mapStateToProps = (state: IStoreState) => ({
  biometrics: state.biometrics,
});

const mapDispatchToProps = (dispatch: Dispatch<UnknownAction>) =>
  bindActionCreators({ saveBiometrics }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BiometricsModal);
